import "./List.css";
import "./LocationList.css";

import queryString from "query-string";
import React from "react";
import { Link } from "react-router-dom";

const LocationList = ({ locations }) => (
  <div className="location-list">
    {locations.map((location, i) => (
      <Link
        className="list-item"
        to={{
          pathname: "/find",
          search: queryString.stringify({
            lat: location.lat,
            lon: location.lon,
          }),
        }}
        key={i}
      >
        <div style={{ width: "auto", margin: "0 auto" }}>
          {location.display_name}
        </div>
      </Link>
    ))}
  </div>
);

export default LocationList;
